import React, { useEffect, useState } from "react";
import { LOGO_URL as logo } from '../../../services'
import CustomInput from "../../../components/CustomInput/CustomInput";
import CheckBox from "../../../components/CheckBox/CheckBox";
import Services from "../../../services/Services";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/Spinner/Spinner";
import { useAuth } from "../../../AuthContext";
import { getLoginPortal, getPortal, getPortalUrl, PORTAL_TYPE_LABELS } from "../../../utils/portal";
import { tokenVadesiniKaydet } from "../../../utils/oturum";
import { klavyeIleTikla } from "../../../utils/a11y"; // FE-78: tıklanabilir öğelerde klavye desteği

const LoginForm = () => {
    const navigate = useNavigate();
    const { setUserType } = useAuth();
    const [token, setToken] = useState();
    const [rememberMe, setRememberMe] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showError, setShowError] = useState(false);
    // İşten ayrılan (devre dışı, users.status=9) hesap: BE doğru parolada "Invalid Account" döner.
    const [accountDisabled, setAccountDisabled] = useState(false);
    // 19.10.2026: mağazadan (site) üye olup e-posta bağlantısına tıklamamış hesap (API users.php login)
    const [emailUnverified, setEmailUnverified] = useState(false);
    // FE-76: hesap başka portala ait (ör. müşteri hesabıyla partner portalı) → doğru adres gösterilir.
    const [wrongPortalType, setWrongPortalType] = useState("");
    // FE-77: oturum API'de düştüğü için girişe dönüldüyse bir kez bilgi verilir.
    const [oturumBitti] = useState(() => {
        try { const v = sessionStorage.getItem("oturumBitti") === "1"; sessionStorage.removeItem("oturumBitti"); return v; } catch (e) { return false; }
    });
    const [showConnectionError, setShowConnectionError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const getToken = () => {
        Services.GetToken()
            .then((res) => {
                if (res.data.status) {
                    setToken(res.data.result.token);
                }
            })
            .catch(() => { /* misafir token alınamadı: giriş denemesinde tekrar denenir */ })
    };

    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        const storedUsername = localStorage.getItem("username");
        // Otomatik yönlendirme YALNIZ geçerli bir oturum (token) varken yapılır. Yalnız
        // "username" kalmışsa (ör. zorunlu çıkış token'ı silip username'i bıraktığında)
        // eskiden /homepage'e yönleniyor, ProtectedRoute geri atıyor ve sonsuz döngü
        // oluşuyordu; ayrıca misafir token alınmadığı için "Giriş Yap" da çalışmıyordu.
        if (storedUsername && storedToken) {
            setToken(storedToken);
            setEmail(storedUsername);
            setRememberMe(true);
            navigate('/homepage');
        } else {
            if (storedUsername) {
                setEmail(storedUsername);
                setRememberMe(true);
            }
            getToken();
        }
    }, [navigate]);

    const handleLogin = () => {
        setIsLoading(true)
        setShowConnectionError(false)
        setAccountDisabled(false)
        setEmailUnverified(false)
        setWrongPortalType("")
        if (!token) {
            // Misafir token alınamamışsa: doğru şifreye bile "Kullanıcı adı veya şifre hatalı"
            // demek yanıltıcı; bu bir bağlantı sorunu. Ayrı mesaj gösterilir ve token yeniden alınır.
            setIsLoading(false)
            setShowConnectionError(true)
            setShowError(false)
            getToken()
            return;
        }
        else {
            Services.UserLogin(token, email, password, getLoginPortal())
                .then((res) => {
                    // Misafir token'ı 7 gün geçerli: sayfa uzun açık kaldıysa süresi dolmuş olabilir → yenisi alınır,
                    // kullanıcıya bağlantı hatası denir (bir kez daha "Giriş Yap" yeni token'la çalışır).
                    if (!res.data.status && /invalid token/i.test(String(res.data.message || ""))) {
                        setToken(undefined);
                        setShowConnectionError(true);
                        getToken();
                        return;
                    }
                    if (res.data.status) {
                        // Domain bazlı giriş kısıtı: bu alt domain yalnız kendi kullanıcı tipini
                        // kabul eder (my→customer, partner→merchant, panel→admin). Yanlış tip
                        // için oturum AÇILMAZ; kimlik hatası gibi davranılır (localhost'ta kısıt yok).
                        const portal = getPortal();
                        const loggedInType = res.data.result.type;
                        if (portal && loggedInType && loggedInType !== portal) {
                            // Oturum yine AÇILMAZ; ama "şifre hatalı" demek yanıltıcıydı (şifre doğru).
                            setWrongPortalType(PORTAL_TYPE_LABELS[loggedInType] ? loggedInType : "");
                            setShowError(true);
                            return;
                        }
                        localStorage.setItem("name", res.data.result.name);
                        localStorage.setItem("lastname", res.data.result.lastname);
                        localStorage.setItem("token", res.data.result.token);
                        tokenVadesiniKaydet(res.data.result);
                        localStorage.setItem("userID", res.data.result.userID);
                        setUserType(res.data.result.type)
                        // İLK GİRİŞ: geçici (6 haneli) şifreyle girildiyse kullanıcı profil
                        // sayfasında şifresini değiştirmeye yönlendirilir. BE bu bilgiyi
                        // yanıtta isFirstLogin olarak veriyordu ama FE hiç okumuyordu.
                        const isFirstLogin =
                            String(res.data.result.isFirstLogin ?? res.data.result.is_first_login ?? "") === "1" ||
                            res.data.result.isFirstLogin === true;
                        if (rememberMe) {
                            localStorage.setItem("username", email);
                        }
                        if (isFirstLogin && res.data.result.type === "customer") {
                            // Müşteri şifre ekranına HAPSEDİLMEZ: anasayfaya iner, üstteki sarı
                            // bant şifre yenilemeye çağırır (şifre değişince bant kalkar).
                            localStorage.setItem("passwordRenewalPending", "1");
                            navigate('/homepage')
                        } else if (isFirstLogin) {
                            navigate('/profile', { state: { profileTab: "security", firstLogin: true } })
                        } else {
                            navigate('/homepage')
                        }
                    }
                    else {
                        setAccountDisabled(String(res?.data?.message || "").trim().toLowerCase() === "invalid account")
                        setEmailUnverified(/doğrulanmadı/i.test(String(res?.data?.message || "")))
                        setShowError(true)
                    }
                })
                // Ağ hatasında buton kalıcı spinner'da kilitleniyordu.
                .catch(() => setShowError(true))
                .finally(() => setIsLoading(false))
        }
    }

    return (
        <div className="login-form"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    if (email && password) {
                        handleLogin();
                    }
                }
            }}
        >
            <div className="logo-container">
                <img src={logo} alt="Troy Depo" />
            </div>
            <div className="hello-message">
                <span style={{ fontWeight: '600', color: 'rgba(10, 34, 82, 1)', fontSize: '32px' }}>Giriş Yap</span>
                <span style={{ fontWeight: '500', color: 'rgba(159, 164, 170, 1)', fontSize: '16px' }}>
                    Hizmetlerimize erişmek için lütfen oturum açın.
                </span>
            </div>

            <div className="login-form-input-holder">
                {/* value KONTROLLÜ: eskiden value prop'u olmadığından, hatırlanan kullanıcı
                    adında alan BOŞ görünüyor ama state'te eski e-posta duruyor ve giriş o
                    değerle yapılıyordu (kutu boşken bile). */}
                <CustomInput value={email} onChange={(e) => setEmail(e.target.value)} label={"E-posta Adresi"} type="email" name="email" autoComplete="username" />
                <CustomInput value={password} onChange={(e) => setPassword(e.target.value)} label={"Şifre"} type="password" name="password" autoComplete="current-password" />
            </div>

            {oturumBitti && !showError &&
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <span style={{ fontSize: '14px', fontFamily: 'Plus Jakarta Sans', color: '#B45309' }}>Oturumunuz sona erdi. Lütfen tekrar giriş yapın.</span>
                </div>
            }
            {showConnectionError &&
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <span style={{ fontSize: '14px', fontFamily: 'Plus Jakarta Sans', color: '#FF3333' }}>Bağlantı kurulamadı. Lütfen tekrar deneyin.</span>
                </div>
            }
            {showError &&
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '34px' }}>
                    <span style={{ fontSize: '14px', fontFamily: 'Plus Jakarta Sans', color: '#FF3333' }}>
                        {wrongPortalType ? (
                            <>
                                Bu bir {PORTAL_TYPE_LABELS[wrongPortalType]} hesabı. Lütfen{" "}
                                <a href={getPortalUrl(wrongPortalType)} style={{ color: "#FF3333", fontWeight: 700 }}>
                                    {getPortalUrl(wrongPortalType).replace(/^https?:\/\//, "")}
                                </a>{" "}
                                adresinden giriş yapın.
                            </>
                        ) : accountDisabled
                            ? "Hesabınız devre dışı bırakılmıştır. Giriş yapamazsınız."
                            : emailUnverified
                                ? "E-posta adresiniz henüz doğrulanmadı. Size gönderdiğimiz bağlantıya tıklayarak hesabınızı onaylayın."
                                : "Kullanıcı adı veya şifre hatalı!"}
                    </span>
                </div>
            }

            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '19px', marginBottom: '34px' }}>
                <span role="button" tabIndex={0} onKeyDown={klavyeIleTikla} onClick={() => setRememberMe(!rememberMe)} style={{ flexDirection: 'row', display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
                    <CheckBox isSelected={rememberMe} />
                    <span className="remember-me">Beni Hatırla</span>
                </span>

                <span role="button" tabIndex={0} onKeyDown={klavyeIleTikla} className="forgot-password" onClick={() => navigate('/forgot-password')}>Şifremi Unuttum</span>
            </div>


            {!isLoading ?
                <button className="login-button" disabled={!email || !password} onClick={handleLogin}>Giriş Yap</button>
                :
                <button className="login-button" disabled style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}><Spinner size={25} /></button>
            }

            {/* <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: '21px', marginBottom: '20px' }}>
                <div className="login-horizontal-divider" />
                <span className="or">ya da</span>
                <div className="login-horizontal-divider" />
            </div>
            <div className="social-login">
                <button className="social-login-button">
                    <img src={gLogo} />
                    <span>Google ile giriş yap</span>
                </button>
                <button className="social-login-button">
                    <img src={fLogo} />
                    <span>Facebook ile giriş yap</span>
                </button>
            </div> */}

            <div className="have-account">
                <span style={{ color: 'rgba(159, 164, 170, 1)', fontWeight: '500' }}>
                    Hesabınız yok mu?
                </span>
                <span role="button" tabIndex={0} onKeyDown={klavyeIleTikla} onClick={() => navigate('/signup')} style={{ color: 'rgba(80, 185, 100, 1)', fontWeight: '600', cursor: 'pointer' }}>
                    Hesap Oluşturun
                </span>
            </div>

            <span className="copyright">
                ©Copyright 2025. All Right Reserved
            </span>
        </div>
    );
};

export default LoginForm;